import React from "react";
import styles from "../styles/Services.module.css";

const Services: React.FC = () => {
  const services = [
    {
      title: "🛒 Purchasing",
      description:
        "We help you select and purchase the perfect vehicle from trusted international markets, tailored to your budget and preferences.",
    },
    {
      title: "🚢 Shipping",
      description:
        "Reliable international shipping to Uganda, ensuring your car arrives safely and on time with full tracking support.",
    },
    {
      title: "📦 Clearing & Forwarding",
      description:
        "We manage all customs clearance procedures and logistics for seamless delivery to your doorstep.",
    },
    {
      title: "📝 Registration",
      description:
        "Professional vehicle registration assistance in Uganda, ensuring compliance with all local regulations.",
    },
  ];

  return (
    <div className={styles.servicesPage}>
    {/* Services Section */}
    <section className={styles.services}
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL}/background.jpg)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'scroll',
    }}>
      <h2>OUR SERVICES</h2>
      <div className={styles.serviceCards}>
        <div className={styles.card}>
          <img src={`${process.env.PUBLIC_URL}/car-service.jpg`} alt="Import Assistance" />
          <div>
            <h3>IMPORT ASSISTANCE</h3>
            <p>We handle sourcing and import logistics for your vehicle.</p>
          </div>
        </div>

        <div className={styles.card}>
          <img src={`${process.env.PUBLIC_URL}/inspection.jpg`} alt="Vehicle Inspection" />
          <div>
            <h3>VEHICLE INSPECTION</h3>
            <p>Thorough inspection reports for complete peace of mind.</p>
          </div>
        </div>

        <div className={styles.card}>
          <img src={`${process.env.PUBLIC_URL}/clearance.jpg`} alt="Clearance and Delivery" />
          <div>
            <h3>CLEARANCE & DELIVERY</h3>
            <p>Customs clearance and doorstep delivery within Uganda.</p>
          </div>
        </div>

        <div className={styles.card}>
          <img src={`${process.env.PUBLIC_URL}/consultation.jpg`} alt="Consultation" />
          <div>
            <h3>CONSULTATION</h3>
            <p>Expert advice on vehicle selection, pricing, and registration.</p>
          </div>
        </div>
      </div>
    </section>

    </div>
  );
};

export default Services;
